import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PostCodeComponent from './components/PostCodeComponent';
import ChooseAddressComponent from './components/ChooseAddressComponent';
import InternationalAddressComponent from './components/InternationalAddressComponent';
import LocalAddressComponent from './components/LocalAddressComponent';
import SelectAddressComponent from './components/SelectAddressComponent';
import { CHOOSE_ADD, CHOOSE_ADD_NO, CHOOSE_ADD_YES } from './addressUtils/addressConstants';
import { ContentRevealPanel } from 'web-ui-components/lib/layout/content';
import { Content } from '../../infrastructure/content';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';

const AddressComponentPage = ({
  type,
  onFindAddressClick,
  onAddManuallyClick,
  formValues,
  isPostCodeListError,
  isAddMunuallyClicked,
  onSelectAddressClick,
  postCodeAddressList,
  saveFormValues
}) => {
  const [isManualClick, manualClick] = useState(false);

  return (
    <div>
      {isPostcodeNeeded(formValues, type) && (
        <PostCodeComponent
          type={type}
          onFindAddressClick={(value) => {
            onFindAddressClick(value);
            manualClick(false);
          }}
          onAddManuallyClick={onAddManuallyClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
          isPostCodeListError={isPostCodeListError}
          formValues={formValues}
          postCodeAddressList={postCodeAddressList}
          saveFormValues={saveFormValues}
        />
      )}
      {type !== 'register' && (
        <Content>
          {(content) => (
            <div
              onClick={() => {
                onAddManuallyClick();
                manualClick(true);
              }}
            >
              <ContentRevealPanel
                key={`local_${isAddMunuallyClicked}`}
                headingText={content.addManually}
                isOpen={
                  isManualClick ||
                  formValues[`${type}.BuildingNumber`] ||
                  formValues[`${type}.AddressLine`]
                }
              >
                <ChooseAddressComponent
                  type={type}
                  formValues={formValues}
                  chooseAddress={(name, value) => {
                    saveFormValues(name, value);
                    value && value[CHOOSE_ADD] === CHOOSE_ADD_NO && manualClick(false);
                  }}
                  isValidate={isManualClick}
                />

                <ConditionalPanel
                  isVisible={formValues[type] && formValues[type][CHOOSE_ADD] ? true : false}
                >
                  {formValues[type] && formValues[type][CHOOSE_ADD] === CHOOSE_ADD_YES && (
                    <LocalAddressComponent
                      type={type}
                      formValues={formValues}
                      fieldValueChanged={saveFormValues}
                      isValidate={isManualClick}
                    />
                  )}
                  {formValues[type] && formValues[type][CHOOSE_ADD] === CHOOSE_ADD_NO && (
                    <InternationalAddressComponent
                      type={type}
                      formValues={formValues}
                      fieldValueChanged={saveFormValues}
                    />
                  )}
                </ConditionalPanel>
              </ContentRevealPanel>
            </div>
          )}
        </Content>
      )}

      {type === 'register' && (
        <Content>
          {(content) => (
            <div
              onClick={() => {
                onAddManuallyClick();
                manualClick(true);
              }}
            >
              <ContentRevealPanel
                key={`local_${isAddMunuallyClicked}`}
                headingText={content.addManually}
                isOpen={isManualClick}
              >
                <LocalAddressComponent
                  type={type}
                  formValues={formValues}
                  fieldValueChanged={saveFormValues}
                  isValidate={isManualClick}
                />
              </ContentRevealPanel>
            </div>
          )}
        </Content>
      )}
      {!isAddMunuallyClicked && postCodeAddressList && postCodeAddressList.length > 0 && (
        <SelectAddressComponent
          type={type}
          onSelectAddressClick={onSelectAddressClick}
          isAddMunuallyClicked={isAddMunuallyClicked}
          postCodeAddressList={postCodeAddressList}
          formValues={formValues}
          saveFormValues={saveFormValues}
        />
      )}
    </div>
  );
};

AddressComponentPage.propTypes = {
  type: PropTypes.string,
  postAddressList: PropTypes.array,
  formValues: PropTypes.object,
  isPostCodeListError: PropTypes.bool,
  isAddMunuallyClicked: PropTypes.bool.isRequired,
  onFindAddressClick: PropTypes.func.isRequired,
  onAddMauallyClick: PropTypes.func.isRequired
};

const isPostcodeNeeded = (formValues, type) => {
  if (formValues[type] && formValues[type][CHOOSE_ADD] === CHOOSE_ADD_NO) {
    return false;
  }
  return true;
};

export default AddressComponentPage;
